<template>

	<div class="date-filter">

		<div class="date-picker-wrap">

			<div class="date-picker-wrap2">

				<v-date-picker
					v-model='range'
					:is-range="mode === 'range'"
					color="gray"
				>
					<template v-slot="{ inputValue, inputEvents, togglePopover }">
						<input
							class="date-input"
							:value="formatDisplayValue(inputValue)"
							:placeholder="placeholder"
							readonly
							@click="togglePopover"
							v-on="inputEvents"
						/>
					</template>
				</v-date-picker>

			</div>

			<span class="clear" v-if="hasValue" @click="clear">X</span>

		</div>

	</div>

</template>

<script>
import Vue from 'vue';
import VCalendar from 'v-calendar';
import { ref, watch, computed } from 'vue';

Vue.use(VCalendar);

export default {
	name: 'DateFilter',
	components: {},
	props: {
		placeholder: {
			type: String,
			default: "Filter by date"
		},
		mode: {
			type: String,
			default: 'range'
		},
		value: {
			type: [String,Array,Number,Date,Object],
			default: ''
		},
		fixed: {
			type: Boolean,
			default: false
		}
	},
	setup(props, { emit }) {
		const range = ref({});

		if (props.value !== '') {
			range.value = typeof props.value === 'string' ? new Date(props.value) : props.value;
		}

		watch(range, (newValue, oldValue) => {
			if (newValue === null || oldValue === null) {
				emit('change', newValue);
			} else {
				if (props.mode === 'range') {
					if (newValue.start !== oldValue.start || newValue.end !== oldValue.end) {
						emit('change', newValue);
					}
				}
				if (props.mode === 'single') {
					if (newValue !== oldValue) {
						emit('change', newValue);
					}
				}
			}
		}, { deep: true });

		const hasValue = computed(() => {
			if (!range.value) return false;
			if (props.mode === 'range') {
				return range.value && range.value.start && range.value.end;
			}
			return range.value !== null && range.value !== undefined;
		});

		const action = (a) => {
			emit(a);
		};

		const clear = () => {
			range.value = null;
			action('clear');
		};

		const formatDate = (date) => {
			if (!date) return '';
			if (typeof date === 'string') return date;
			if (date instanceof Date) {
				return date.toLocaleDateString();
			}
			return '';
		};

		const formatDisplayValue = (inputValue) => {
			if (!inputValue) return '';
			
			if (props.mode === 'range') {
				// For range mode, inputValue is an object with start and end properties
				if (typeof inputValue === 'object' && inputValue.start && inputValue.end) {
					return `${formatDate(inputValue.start)} - ${formatDate(inputValue.end)}`;
				} else if (typeof inputValue === 'object' && inputValue.start) {
					return formatDate(inputValue.start);
				}
				return '';
			} else {
				// For single mode, inputValue should be a formatted string already
				if (typeof inputValue === 'string') {
					return inputValue;
				} else if (inputValue instanceof Date) {
					return formatDate(inputValue);
				}
				return '';
			}
		};

		return {
			range,
			hasValue,
			clear,
			formatDisplayValue
		};
	}
}
</script>
<style lang="less" scoped>
.date-filter {

	.date-picker-wrap {

		width: 100%;

		.vc-border {

		    border-width: 0px;

		}

		.date-picker-wrap2 {

			display: inline-block;

		}

	}

}

</style>
<style lang="less">
@import './../../assets/css/less/_settings.less';
.date-filter {

	.date-picker-wrap {

		position: relative;

		.clear {

			cursor: pointer;
			font-size: 80%;
			color: @formDefaultColour;
			display: block;
			position: absolute;
			top: 9px;
			right: 6px;
			&:hover {
				text-decoration: underline;
			}

		}

		input,
		.date-input {

		    border: 1px solid rgba(0, 0, 0, 0.1);
		    padding: 6px 20px 6px 6px;
		    width: 100%;
		    cursor: pointer;

		}

		.vc-popover-content-wrapper {

			left:-30px !important;

		}

		.date-picker-wrap2 {

			width: 100%;
			margin-top: 3px;

		}

	}

	&.table-filter {

		.date-picker-wrap {

			input {

				background-color: #F8FAFB;
				-webkit-font-smoothing: antialiased;
    			-moz-osx-font-smoothing: grayscale;

			}

		}

	}

}

@media screen and (min-width: 1024px) {

	.date-filter {

		.date-picker-wrap {

			.vc-popover-content-wrapper {

				left:-30px !important;

			}

		}

	}

}

</style>